// One stat tile for every sourcing screen (Lane 1362, Ryan: the Overview's "Change against
// today" figure rendered smaller than the three beside it). The figure was wrapped in
// `.srce-good`, a small-text note class (12.5px), so it lost the tile's 20px. Now every
// tile is this component: the label, one figure and an optional note, all at the tile's
// own sizes. A tone (good, crit) only colours the figure, through a tile class that sets
// no size; the figure is plain text, so no other class can reach it. The figure sits in a
// `.srce-tile-vbox` box, which is the size container for its font size; the tile itself
// must not be a container (see SourcingEvents.css, Lane 1372).
import React from 'react';

export const STAT_TONES = ['good', 'crit'];

function text(value) {
  if (value === null || value === undefined || value === '') return '-';
  return typeof value === 'number' ? value.toLocaleString() : String(value);
}

// `onClick` makes the whole tile a button (the recommendation opens Scenarios).
export default function StatTile({ label, value, note, tone, onClick, disabled }) {
  const figure = (
    <>
      <div className="srce-tile-k">{label}</div>
      <div className="srce-tile-vbox">
        <div className={`srce-tile-v${STAT_TONES.includes(tone) ? ` srce-tile-v--${tone}` : ''}`} title={text(value)}>{text(value)}</div>
      </div>
      {note !== undefined && <div className="srce-tile-s">{note}</div>}
    </>
  );
  if (onClick) {
    return <button type="button" className="srce-tile srce-tile--btn" onClick={onClick} disabled={disabled}>{figure}</button>;
  }
  return <div className="srce-tile">{figure}</div>;
}
